<template>
  <div class="circle" @click="$emit('selected')" :style="`background-color:${color}`">
      <b-icon v-if="isSelected" icon="check" class="check" ></b-icon> 
      <b-icon v-if="advanced && !isSelected" icon="ellipsis-h" class="check" ></b-icon> 
  </div>
</template>

<script>
export default {
  name:"ColorOption",
  props:{
    isSelected:{
      type:Boolean,
      required:false,
      defaut:false
    },
    color:{
      type:String,
      required:true
    },
    advanced:{
      type:Boolean,
      required:false
    }
  }
}
</script>

<style>
.circle{
  display: flex;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50px;
  margin-right: 6px;
  margin-bottom: 6px;
}
.check{
    margin:auto;
}
</style>